module.exports = __webpack_public_path__ + "img/2.d1008c40.jpg";